import React, { useState } from 'react';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    display: "flex",
    boxShadow: `0px ${theme.spacing(0.2)} ${theme.spacing(0.5)} ${theme.palette.grey[100]}, 0px 0px ${theme.spacing(2)} ${theme.palette.grey[100]}`,
    borderRadius: theme.spacing(3),
    height: 32,
}));
const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
    "&.MuiToggleButton-root": Object.assign(Object.assign({ flexBasis: "100%", color: theme.palette.text.disabled, textTransform: "capitalize", border: `${theme.spacing(0.1)} solid transparent` }, theme.typography.h4), { fontWeight: theme.typography.fontWeightBold, ":hover": {
            backgroundColor: "transparent",
        }, "&.Mui-selected": {
            borderRadius: `${theme.spacing(3)} !important`,
            color: theme.palette.text.secondary,
            boxShadow: `0px 0px ${theme.spacing(0.1)} ${theme.palette.grey[100]}, 0px 0px ${theme.spacing(1.6)} ${theme.palette.grey[100]}`,
            "&.MuiToggleButton-secondary": {
                backgroundColor: theme.palette.secondary.main,
            },
            "&.MuiToggleButton-primary": {
                backgroundColor: theme.palette.primary.main,
            },
        } }),
}));
const PeekToggleSwitch = ({ onProps, offProps, onChange, value, color = "primary", }) => {
    const [switchValue, setSwitchValue] = useState(value || onProps.value);
    const handleChange = (event, sValue) => {
        if (sValue !== undefined && sValue !== null) {
            setSwitchValue(sValue);
            onChange(sValue);
        }
    };
    return (React.createElement(StyledToggleButtonGroup, { color: color, value: switchValue, exclusive: true, orientation: "horizontal", onChange: handleChange },
        React.createElement(StyledToggleButton, { key: "on", value: onProps.value }, onProps.label),
        React.createElement(StyledToggleButton, { key: "off", value: offProps.value }, offProps.label)));
};

export { PeekToggleSwitch, StyledToggleButton, StyledToggleButtonGroup, PeekToggleSwitch as default };
